import { render, staticRenderFns } from "./SidebarEditCompany.vue?vue&type=template&id=df35be48&scoped=true"
import script from "./SidebarEditCompany.vue?vue&type=script&lang=js"
export * from "./SidebarEditCompany.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditCompany.vue?vue&type=style&index=0&id=df35be48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df35be48",
  null
  
)

export default component.exports